import { configConstants } from '../constants'

const initialState = {
  loading: false,
  error: null,
  settings: null,
  init: false,
  render: false
}

export default function config(state = initialState, action) {
  switch (action.type) {
    case configConstants.CONFIG_LOAD:
      return {
        ...state,
        loading: true,
        settings: null,
        init: true,
        render: false
      }
    case configConstants.CONFIG_LOAD_SUCCESS:
      return {
        ...state,
        settings: action.payload
      }
    case configConstants.CONFIG_RENDER_SUCCESS:
      return {
        ...state,
        render: true,
        loading: false
      }
    case configConstants.CONFIG_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case configConstants.CONFIG_RESET:
      return {
        ...initialState
      }
    default:
      return state
  }
}
